import config from "@/config";

const imageConfig = {
    getLogo : (data) => {
        return data ? `data:image/png;base64,${data}` : config.webConfig.logo;
    },

    getBanner : (data) => {
        return data ? `data:image/png;base64,${data}` : config.webConfig.defaultBanner;
    },
}

export default imageConfig;